import { makeStyles, Theme } from '@material-ui/core/styles'

export default makeStyles<Theme>(theme => ({
  root: {
    width: 850,
    backgroundColor: '#fff',
    borderRadius: 0,
    position: 'relative',
    padding: '0 50px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    [theme.breakpoints.down('md')]: {
      width: 'calc(100vw - 25px)',
      padding: 10,
      minHeight: 'unset',
      borderRadius: 12
    }
  },
  passionContainer: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    padding: 0,
    transition: 'all 0.3s ease',
    [theme.breakpoints.down('xs')]: {
      paddingBottom: 45
    }
  },
  freeTextRoot: {
    display: 'flex'
  },
  titleInputContainer: {
    marginBottom: 0,
    '&  p': {
      fontSize: 24,
      fontWeight: 500
    },
    [theme.breakpoints.down('xs')]: {
      '&  p': {
        fontSize: 18,
        paddingTop: 0
      }
    }
  },
  detailBox: {
    paddingLeft: 50,
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0
    }
  },
  detailInputContainer: {
    width: '100%',
    '&  p': {
      fontWeight: 300,
      lineHeight: '40px',
      color: theme.palette.common.darkGrey
    },
    '& .MuiInputBase-root': {
      backgroundColor: '#fff'
    },
    [theme.breakpoints.down('xs')]: {
      '&  p': {
        fontSize: 12,
        lineHeight: '20px'
      }
    }
  }
}))
